import { Trace } from '../../../domain/Trace'
import { TraceSummary } from '../../../domain/TraceSummary'
import { ApplicationState } from '../../ApplicationState'
import { getTraceState } from '../V2State'

export interface TraceState {
    byId: { [id: string]: Trace }
    summariesById: { [id: string]: TraceSummary }
    historySummaryIds: string[]
    loaded: { [id: string]: boolean }
    historyLoaded: boolean
}

export const getTrace = (state: ApplicationState, id: string): Trace | null => getTraceState(state)?.byId[id] || null

export const isTraceLoaded = (state: ApplicationState, id: string): boolean => getTraceState(state)?.loaded[id] || false

export const getHistoryTraceSummaries = (state: ApplicationState): TraceSummary[] =>
    getTraceState(state).historySummaryIds.map(id => getTraceState(state).summariesById[id])

export const areTraceHistorySummariesLoaded = (state: ApplicationState): boolean => getTraceState(state).historyLoaded
